export default __webpack_public_path__ + "static/car_w.b46744a1aeb895667ef521c827f374c4.png";